export default function FooterSection() {
  return (
    <div className="footer-section">
      <h5>© Copyright © 2022 Your News App</h5>
    </div>
  );
}
